
		<acc-common-folder-structure [showFolderTooltip]="showFolderTooltip" [folderTooltip]="folderTooltip"  [folders]="folders" (onAction)="folderAction($event)" [(activeFolder)]="activeFolder" [showFolderActions]="showFolderActions" [showCartActions]="showCartActions"></acc-common-folder-structure>
